export const REMOVE_USER_CONFIRM_MESSAGE: string =
  "Are you sure you want to remove user";
